import PageFilters from '@/components/PageFilters/PageFilters';

export default PageFilters;
